import Http from './http'

export default {
	index(){
    return Http.get('/roles')
  },
  show(id){
    return Http.get(`/roles/${id}`)
  },
}